<template>
    <b-container class="reporting-info-container">
        <b-row>

            <b-col cols=12 md=auto class="mt-3">
                <div class="d-flex flex-row align-items-center">
                    <label class="filter-label" :for="'fromDate'">From</label>
                    <div class="ml-2 w-100 px-4 px-md-1">
                        <b-form-datepicker :date-format-options="dateFormatOption" :min="minFromDate" :max="maxFromDate"
                            class="filter-date-input-white notranslate" :id="'fromDate'" type="date" v-model="fromDate">
                        </b-form-datepicker>
                    </div>
                </div>
            </b-col>

            <b-col cols=12 md=auto class="mt-3">
                <div class="d-flex flex-row align-items-center">
                    <label class="filter-label" :for="'toDate'">To</label>
                    <div class="ml-2 w-100 px-4 px-md-1">
                        <b-form-datepicker :date-format-options="dateFormatOption" :min="minToDate" :max="maxToDate"
                            class="filter-date-input-white notranslate" :id="'toDate'" type="date" v-model="toDate">
                        </b-form-datepicker>
                    </div>
                </div>
            </b-col>

            <b-col md=auto>
                <b-button class="date-button" variant="primary" @click="dateFilter">Apply</b-button>
            </b-col>

            <b-col md=auto>
                <b-button class="clear-button" variant="secondary" @click="clearDateFilter">Clear</b-button>
            </b-col>
            <div class="card px-4">
                <div class="border-0">
                    <div class="card-body px-0 rounded overflow-auto">
                        <div class="b2b-table">
                            <b-table id="userTable" striped hover :items="rowsUser" :busy="isLoading">
                                <template #cell(videoThumbnail)="row">
                                <div class="d-flex justify-content-start">
                                    <div class="video-slot">
                                        <img class="imgClass" :src="row.item.videoThumbnail"/>
                                    </div>
                                </div>
                            </template>
                            </b-table>
                        </div>
                        <div class="pagination">
                            <Multiselect :options="pageSizeArray" v-model="pageSizeUser" class="pageSizeMS" />
                            <b-pagination v-model="pageUser" :total-rows="totalRecordsUser" :per-page="pageSizeUser" />
                        </div>
                    </div>
                </div>
            </div>

        </b-row>
    </b-container>
</template>

<script>
import API from "../api.js"
import Multiselect from 'vue-multiselect';
import router from "@/router";
import moment from 'moment'

export default {
    name: "ReportinguserDetails",

    data() {
        return {
            minFromDate: undefined,
            maxFromDate: undefined,
            minToDate: undefined,
            maxToDate: undefined,
            fromDate: '',
            toDate: '',
            dateFormatOption: { year: 'numeric', month: 'short', day: '2-digit' },
            isLoading: false,
            rowsUser: [],
            pageSizeUser: 20,
            pageUser: 1,
            userId:this.$route.params.id,
            pageSizeArray: [10, 20, 50, 100],
            totalRecordsUser: 0,
        }
    },
    mounted() {
        this.toDate = moment().format('YYYY-MM-DD');
        this.fromDate = moment().subtract(2, 'months').format('YYYY-MM-DD');
        this.corporateUsersDetails();
    },
    methods: {

        dateFilter() {
            this.corporateUsersDetails()
        },
        clearDateFilter(){
        this.toDate = moment().format('YYYY-MM-DD');
        this.fromDate = moment().subtract(2, 'months').format('YYYY-MM-DD');
        this.corporateUsersDetails();
        },

        async corporateUsersDetails() {
            try {
                const corporateUsersDetailsParam = {
                    fomDate:this.fromDate,
                    toDate:this.toDate,
                    userId: this.userId,
                    perPage: this.pageSizeUser,
                    page: this.pageUser
                }
                let res = await API.corporateUsersDetails(corporateUsersDetailsParam)
                this.rowsUser = [];
                let count = 1;
                res.data.rows.forEach((item) => {
                    this.rowsUser.push({
                        s_no:count++,
                        videoThumbnail:item.videoThumbnail,
                        videoTitle:item.videoTitle,
                        videoTenantName:item.videoTenantName,
                        videoDuration: this.secondsToMinutes(item.videoDuration),
                        caloriesBurnt: item.caloriesBurnt,
                        completed: item.completed + " %",
                        score: item.score + " %",
                        workoutDuration:item.workoutDuration + " seconds",
                        workout_date: moment(item.createdAt).format('YYYY-MM-DD'),
                    });
                });
                this.totalRecordsUser = res.data.total
            }
            catch (error) {
                console.log("There is an error in corporateUsersDetails", error);
            }
        },

        secondsToMinutes(total) {
            let minutes = 0;
            let hours = 0;
            let seconds = 0;
            minutes = Math.trunc(total / 60);
            seconds = total % 60;
            hours = Math.trunc(minutes / 60);
            minutes = Math.trunc(minutes % 60);

            if (hours > 0)
                return hours + ":" + minutes + ":" + seconds

            else return minutes + ":" + seconds
        },
    },

    watch: {
        fromDate: function (val) {
            ''
            this.minToDate = new Date(val);
        },
        toDate: function (val) {
            this.maxFromDate = new Date(val);
        },
        pageUser() {
            this.corporateUsersDetails();
        },
        pageSizeUser() {
            if (this.pageSizeUser !== 0) {
                this.corporateUsersDetails();
            }
        },
    },
    components: {
        Multiselect
    },
}
</script>

<style lang="scss" scoped>
// Multiselect
::v-deep .multiselect__tags {
    min-height: 0;
    padding: 0;
    background: #FFFFFF !important;
    border: 2px solid #73BC44;
    border-radius: 5px !important;
    height: 34px !important;
    min-width: 135px !important;
    display: flex;
    align-items: center;
}

::v-deep .multiselect__placeholder {
    margin: 5px 0 5px 10px;
    color: #969B92;
    font-weight: 500;
}

::v-deep .multiselect__single {
    margin-bottom: 0px !important;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #141513 !important;
}

::v-deep .multiselect__select:before {
    color: #73BC44 !important;
    border-color: #73BC44 transparent transparent;
}

::v-deep .multiselect__tags-wrap {
    display: flex !important;
    align-items: center !important;
}

::v-deep .multiselect__tag {
    margin-bottom: 0;
}

// Card Body
.card {
    border: none;
    background-color: #323232;
    margin-top: 20px;

    .card-body {
        position: relative;
        padding-bottom: 30px;

        .info-card-title {
            color: #41c300;
            font-weight: bold;
        }

        .value {
            font-size: xx-large;
        }

        .message {
            font-size: small;
            position: absolute;
            bottom: 15px;
            width: 85%;
        }

        .table {
            cursor: pointer;
        }
    }
}

.border-card {
    border: 2px solid #969B92 !important;
    background-color: #F4F6F9;
    box-shadow: none;
    color: #141513;

    .card-body {
        .info-card-title {
            color: #969B92;
            font-weight: bold;
            font-size: 12px;
            line-height: 18px;
        }

        .value {
            font-weight: bold;
            font-size: 16px !important;
            line-height: 24px;
        }
    }
}

.i-border {
    border: 1px solid #73BC44;
    border-radius: 50%;
    height: 18px;
    width: 18px;
    text-align: center;
    justify-content: center;
    display: inline-block;
    font-size: 11px;
    color: #fff;
    margin-left: 2px;
    transform: translateY(-2px);
}

// Breadcrumbs
.breadCrumb {
    background-color: #323232;
}

/* Date Picker and Buttons */
.row {
    margin: 0px;
}

.col {
    margin: 10px;
    padding-right: 0px;
    padding-left: 0px;
}

.filter-label {
    top: 50%;
    font-weight: bold;
    font-size: 12px;
    line-height: 18px;
    color: white;
}

.mt-3.col-md-auto.col-12 {
    padding: 5px;
}

.col-md-12.mb-0 {
    padding: 0px;
}

.col-md-auto {
    padding: 10px;
}

.date-button {
    margin-top: 10px;
    height: 35px;
}

.clear-button {
    margin-top: 10px;
    height: 35px;
}

// Button Tabs
.buttons {
    margin-right: 10px;
    margin-bottom: 30px;
}

.buttons-container {
    margin-top: 30px;
    margin-left: 15px;
}

// Client Search Bar
.col-3 {
    padding: 0px;
    margin-top: 10px;
    margin-right: 5px;
}

// Pagination
.pageSizeMS {
    width: 200px;
    margin-left: 10px;
    margin-right: 25px;
}

.imgClass  {
    width: 90px;
    height: 90px;
}
</style>